import Service from "../../../../utils/api/service";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import _debounce from "lodash.debounce";
export default {
  name: "EditCoupon",
  data() {
    return {
      isUpdating: false,
      freeShipping: true,
      loading: {
        isProductSearching: false,
        isVariantSearching: false,
        customerLoading: false,
        categoryLoading: false,
        customerGroupLoading: false,
      },
      isLoading: true,
      body: {
        name: "",
        code: "",
        type: "percentage",
        discount: 0,
        freeShipping: false,
        categoryId: [],
        productId: [],
        variantIds: [],
        customerGroupIds: [],
        customerIds: [],
        customerGroupAction: "include", // include | exclude
        minAmount: 0,
        minQty: 0,
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        usesTotal: 0,
        usesCustomer: 0,
        status: "active", // active | inactive
        viewType: "select", // select | input
        customerAction: "include", // include | exclude
        minOrderOption: "minimum amount", // amount | quantity
        combineCustomerDiscount: false, // true | false
        combineProductDiscount: false, // true | false
        description: "",
      },
      data: {
        productList: [],
        categories: [],
        customers: [],
        customerGroups: [],
        variants: [],
      },
      display: {
        category: false,
      },
      model: {
        products: [],
        variants: [],
        categories: [],
        customers: [],
        customerGroups: [],
      },
      showTimePanel: false,
      showTimeRangePanel: false,
      actions: [
        { id: "include", name: "Include" },
        { id: "exclude", name: "Exclude" },
      ],
      discountTypes: [
        { id: "fix_amount", name: "Fixed Amount" },
        { id: "percentage", name: "Percentage" },
      ],
      viewTypes: [
        { id: "select", name: "User Select" },
        { id: "input", name: "User Input" },
      ],
      minOrderOptions: ["minimum amount", "minimum quantity"],
    };
  },
  components: { Multiselect, DatePicker },
  computed: {
    debouncedOnSearchProducts() {
      return _debounce(this.searchProducts, 500);
    },
    debouncedOnSearchVariants() {
      return _debounce(this.searchVariants, 500);
    },
    debouncedOnGetCustomers() {
      return _debounce(this.getCustomers, 500);
    },
  },
  created() {
    this.getCouponDetail(this.$route.query.id);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListCoupon",
        query: {
          page: 1,
          limit: 10,
        },
      });
    },

    getCouponDetail(id) {
      this.isLoading = true;

      Service.getCouponDetail(id).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCouponDetail(id);
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.detail = response.data;
          this.body.status = response?.data?.status;
          // convert date
          let convertStartDate = moment(
            this.reNewTimestamp(this.data.detail.startDate)
          ).toDate();
          let convertEndDate = moment(
            this.reNewTimestamp(this.data.detail.endDate)
          ).toDate();
          this.data.detail.startDate = convertStartDate;
          this.data.detail.endDate = convertEndDate;

          //map category
          this.data.detail.categoryId = [];
          if (this.data.detail.categories.length > 0) {
            for (let i = 0; i < this.data.detail.categories.length; i++) {
              const element = this.data.detail.categories[i];
              this.model.categories.push(element);
            }
          }

          //map product
          this.model.products = [];
          if (this.data.detail.products.length > 0) {
            for (let i = 0; i < this.data.detail.products.length; i++) {
              const element = this.data.detail.products[i];
              this.model.products.push(element);
            }
          }

          //map customer
          this.model.customers = [];
          if (this.data.detail.customers.length > 0) {
            for (let i = 0; i < this.data.detail.customers.length; i++) {
              const element = {
                ...this.data.detail.customers[i],
                fullName:
                  (this.data.detail.customers[i]?.bpName
                    ? this.data.detail.customers[i]?.bpName
                    : this.data.detail.customers[i]?.firstName +
                      " " +
                      this.data.detail.customers[i]?.lastName) +
                  " " +
                  "(" +
                  this.data.detail.customers[i]?.code +
                  ")",
              };
              this.model.customers.push(element);
            }
          }

          // map customer group
          this.model.customerGroups = [];
          if (this.data.detail.customerGroups.length > 0) {
            for (let i = 0; i < this.data.detail.customerGroups.length; i++) {
              const element = this.data.detail.customerGroups[i];
              this.model.customerGroups.push(element);
            }
          }

          /***
           * @set new field
           * - map variants
           */
          this.model.variants = [];
          if (this.data.detail.variants.length > 0) {
            for (let i = 0; i < this.data.detail.variants.length; i++) {
              const element = this.data.detail.variants[i];
              this.model.variants.push(element);
            }
          }
          this.body.viewType = this.data.detail.viewType;
          this.body.customerGroupAction = this.data.detail.customerGroupAction;
          this.body.customerAction = this.data.detail.customerAction;
          this.body.combineCustomerDiscount =
            this.data.detail.combineCustomerDiscount;
          this.body.combineProductDiscount =
            this.data.detail.combineProductDiscount;
          this.body.minOrderOption =
            this.data.detail?.minOrderOption || this.minOrderOptions[0];

          // get important option
          this.getCategory();
          // this.searchProducts();
          // this.getCustomers();
          this.getCustomerGroups();
          this.isLoading = false;
        }
      });
    },

    reNewTimestamp: function (timestamp) {
      const date = new Date(timestamp);
      date.setUTCHours(date.getUTCHours() - 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    getCategory() {
      Service.getAllCategories("").then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCategory();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.categories = response.data;
        }
      });
    },

    getCustomers(query) {
      let param = query ? "?status=active&search=" + query : "?status=active";
      this.loading.customerLoading = true;

      Service.getCustomers(param).then((response) => {
        this.loading.customerLoading = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomers();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let customers = response.data;
          let newList = [
            {
              name: "Select All",
              list: customers.map((item) => {
                return {
                  ...item,
                  fullName:
                    (item?.bpName
                      ? item?.bpName
                      : item?.firstName + " " + item?.lastName) +
                    " " +
                    "(" +
                    item?.code +
                    ")",
                };
              }),
            },
          ];

          this.data.customers = newList;
        }
      });
    },

    getCustomerGroups() {
      let params = "?limit=150&offset=0";

      Service.getCustomerGroups(params).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomerGroups();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.customerGroups = response.data;
        }
      });
    },

    showCheckboxes() {
      if (this.display.category) {
        this.display.category = false;
      } else {
        this.display.category = true;
      }
    },

    searchProducts(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";
      this.loading.isProductSearching = true;

      Service.getAllProducts(param).then((response) => {
        this.loading.isProductSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchProducts();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let productList = response.data;
          let newList = [
            {
              name: "Select All",
              list: productList,
            },
          ];
          this.data.productList = newList;
        }
      });
    },

    searchVariants(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";
      this.loading.isVariantSearching = true;

      Service.getAllProductVariants(param).then((response) => {
        this.loading.isVariantSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchVariants();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let variants = response.data;
          let newList = [
            {
              name: "Select All",
              list: variants,
            },
          ];

          this.data.variants = newList;
        }
      });
    },

    submitUpdateCoupon() {
      let validatedMessage = this.validateBody(this.data.detail);
      if (validatedMessage == "ok") {
        this.isUpdating = true;
        this.updateCoupon();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(body) {
      if (!body.name) {
        return "Coupon Name cannot be empty!";
      } else if (!body.code || body.code.length < 8 || body.code.length > 8) {
        return "Coupon Code cannot be empty and code must be 8 digit!";
      } else if (!body.type) {
        return "Type group cannot be empty!";
      } else if (typeof body.discount === "string" || body.discount <= 0) {
        return "Discount cannot be empty or smaller than zero!";
      } else if (typeof body.usesTotal === "string" || body.usesTotal < 0) {
        return "Uses per coupon cannot be empty or smaller than zero!";
      } else if (
        typeof body.usesCustomer === "string" ||
        body.usesCustomer < 0
      ) {
        return "Uses per customer cannot be empty or smaller than zero!";
      } else if (
        (typeof body.minAmount === "string" &&
          body.minOrderOption === this.minOrderOptions[0]) ||
        (body.minOrderOption === this.minOrderOptions[0] && body.minAmount < 0)
      ) {
        return "Minimum order amount cannot be empty or smaller than zero!";
      } else if (
        (typeof body.minQty === "string" &&
          body.minOrderOption === this.minOrderOptions[1]) ||
        (body.minOrderOption === this.minOrderOptions[1] && body.minQty < 0)
      ) {
        return "Minimum quantity of item cannot be empty or smaller than zero!";
      } else if (!body.startDate) {
        return "Start date/time cannot be empty!";
      } else if (!body.endDate) {
        return "End date/time cannot be empty!";
      } else if (!body.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    updateTimestamp: function (timestamp) {
      const iso = timestamp.toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() + 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    updateCoupon() {
      this.data.detail.productId = [];
      if (this.model.products) {
        for (let index = 0; index < this.model.products.length; index++) {
          const product = this.model.products[index];
          this.data.detail.productId.push(product.id);
        }
      }

      this.body.customerGroupIds = [];
      if (this.model.customerGroups) {
        for (let index = 0; index < this.model.customerGroups.length; index++) {
          const customerGroup = this.model.customerGroups[index];
          this.body.customerGroupIds.push(customerGroup.id);
        }
      }

      this.body.customerIds = [];
      if (this.model.customers) {
        for (let index = 0; index < this.model.customers.length; index++) {
          const customer = this.model.customers[index];
          this.body.customerIds.push(customer.id);
        }
      }

      this.data.detail.categoryId = [];
      if (this.model.categories) {
        for (let index = 0; index < this.model.categories.length; index++) {
          const product = this.model.categories[index];
          this.data.detail.categoryId.push(product.id);
        }
      }

      this.body.variantIds = [];
      if (this.model.variants) {
        for (let index = 0; index < this.model.variants.length; index++) {
          const variant = this.model.variants[index];
          this.body.variantIds.push(variant.id);
        }
      }

      let couponId = this.$route.query.id;

      /***
       * @no depend field
       * @apply new field name :
       * - viewType
       * - variantIds
       * - combineCustomerDiscount
       * - combineProductDiscount
       * - customerGroupAction
       * - customerAction
       */
      const minOrder =
        this.body.minOrderOption === this.minOrderOptions[0]
          ? this.data.detail?.minAmount ?? 0
          : this.data.detail?.minQty ?? 0;

      const body = {
        name: this.data.detail.name,
        code: this.data.detail.code,
        type: this.data.detail.type,
        discount: this.data.detail.discount ?? 0,
        freeShipping: this.data.detail.freeShipping,
        categoryId: this.data.detail.categoryId,
        productId: this.data.detail.productId,
        customerIds: this.body.customerIds,
        customerGroupIds: this.body.customerGroupIds,
        minAmount:
          this.body.minOrderOption === this.minOrderOptions[0] ? minOrder : 0,
        minQty:
          this.body.minOrderOption === this.minOrderOptions[1] ? minOrder : 0,
        startDate: this.updateTimestamp(this.data.detail.startDate),
        endDate: this.updateTimestamp(this.data.detail.endDate),
        usesTotal: this.data.detail.usesTotal ?? 0,
        usesCustomer: this.data.detail.usesCustomer ?? 0,
        status: this.body.status,

        // new field
        viewType: this.body.viewType,
        customerGroupAction: this.body.customerGroupAction,
        customerAction: this.body.customerAction,
        variantIds: this.body.variantIds,
        combineCustomerDiscount: this.body.combineCustomerDiscount,
        combineProductDiscount: this.body.combineProductDiscount,
        minOrderOption: this.body.minOrderOption,
        description: this.data.detail?.description || "",
      };

      // delete body.code;
      Service.updateCoupon(couponId, body).then((response) => {
        this.isUpdating = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.updateCoupon();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.goBack();
          this.$toasted.show("Coupon has been updated.");
        }
      });
    },

    toUpperCase(string) {
      return string.toUpperCase();
    },

    toCapitalLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
  },
};
